/**
 * @fileoverview UI feature flags.
 *
 * SMS_UI_ENABLED / PUSH_UI_ENABLED hide the text-message and push-notification
 * options everywhere in the UI while the underlying delivery is not yet
 * activated. ALL backend + frontend code stays in place — flipping a flag to
 * true is the entire UI reactivation.
 *
 * Before flipping:
 *   - SMS_UI_ENABLED: Telnyx account + number + 10DLC campaign approved, and
 *     TELNYX_* env vars set on the droplet (see docs/activating-push-and-sms.md).
 *   - PUSH_UI_ENABLED: FCM + APNs credentials on the droplet AND a native app
 *     release with push registration live in the stores (same doc).
 */
export const SMS_UI_ENABLED = false;
export const PUSH_UI_ENABLED = false;
